import { ApolloError, useQuery } from '@apollo/client';
import { GET_TIERS } from '../queries';
import { FetchedTierListOptions } from '../types';

/**
 * This hook is used to fetch the tier list from the database.
 */
export const useTiers = (): {
  data: FetchedTierListOptions['getTiers'] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const result = useQuery<FetchedTierListOptions>(
    GET_TIERS,
  );

  if (result.error) {
    console.error('Tier list GraphQL error:', result.error);
  }

  return {
    data: result.data?.getTiers,
    loading: result.loading,
    error: result.error,
  };
}
